import { HTTP } from "@/axios.js";
import store from "@/store.js";
export default {
  // dashboardList:  (year,month) => {
  //     return HTTP.get('/dashboard?month='+month+'&year='+year, {
  //         headers: {
  //             "Authorization": `Bearer ${store.state.token}`
  //         }
  //     })
  //     .then(response => response)
  // },
  dashboardNew: () => {
    return HTTP.get("/dashboard/new", {
      headers: {
        Authorization: `Bearer ${store.state.token}`,
      },
    }).then((response) => response);
  },

  // วัตถุดิบที่ใกล้หมด
  dashboardMaterialLess: (search, page, size) => {
    return HTTP.post(
      "/dashboard/material/less",
      { search, page, size },
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      }
    ).then((response) => response);
  },
  // ตารางแนะนำราคาขาย
  dashboardFoodPrice: (search, page, size) => {
    return HTTP.post(
      "/dashboard/food/price",
      { search, page, size },
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      }
    ).then((response) => response);
  },

  // filter รายการอาหารขายดี
  dashboardFoodByFilter: (search, page, size, type, year, date_start, date_end) => {
    return HTTP.post(
      "/dashboard/food/by/filter",
      {
        search: search,
        page: page,
        size: size,
        type: type, // type = 0 คือ เลือก ตามเดือน || 1 = เลือกตามปี
        year: year,
        date_start: date_start,
        date_end: date_end,
      },
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      }
    ).then((response) => response);
  },

  // filter ยอดขายร้านอาหาร
  dashboardProfitByFilter: (search, page, size, type, year, date_start, date_end) => {
    return HTTP.post(
      "/dashboard/profit/by/filter",
      {
        search: search,
        page: page,
        size: size,
        type: type, // type = 0 คือ เลือก ตามเดือน || 1 = เลือกตามปี
        year: year,
        date_start: date_start,
        date_end: date_end,
      },
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      }
    ).then((response) => response);
  },
  
  // filter ยอดรายได้ กำไร ต้นทุน ของร้าน
  dashboardIncomeByFilter: (search, page, size, type, year, date_start, date_end) => {
    return HTTP.post(
      "/dashboard/income/by/filter",
      {
        search: search,
        page: page,
        size: size,
        type: type, // type = 0 คือ เลือก ตามเดือน || 1 = เลือกตามปี
        year: year,
        date_start: date_start,
        date_end: date_end,
      },
      {
        headers: {
          Authorization: `Bearer ${store.state.token}`,
        },
      }
    ).then((response) => response);
  },
  
};
